<script lang="ts" setup>
import { inject, computed, watch, ref, onUnmounted } from "vue"
import { deleteEmptyKey } from "@p-v/utils"
import { createBounds } from "@p-v/utils/factory"
import type { Bounds } from "@p-v/packages/Map/map"

interface ComponentProps {
  bounds: Bounds
  imageURL: string
  opacity?: number
  autoCenter?: boolean
}

const props = withDefaults(defineProps<ComponentProps>(), {
  bounds: () => ({
    ne: {
      lng: 116.475451,
      lat: 39.9764,
    },
    sw: {
      lng: 116.29579,
      lat: 39.837146,
    },
  }),
  imageURL: () => "",
  opacity: () => 1,
  autoCenter: () => true,
})

console.log("ground props", props)
const bmap = inject("bmap") as any

let groundOption = {
  type: "image",
  opacity: props.opacity,
  url: props.imageURL,
}
deleteEmptyKey(groundOption)

const groundOverlay = ref<any>(undefined)

watch(
  () => bmap.value,
  value => {
    console.log("ground bmap", value, groundOverlay)
    if (value && groundOverlay.value === undefined) {
      groundOverlay.value = new window.BMapGL.GroundOverlay(props.bounds && createBounds(window.BMapGL, props.bounds), groundOption)
      // overlay.setImage(props.imageURL)
      bmap.value?.addOverlay(groundOverlay.value)
      if (props.autoCenter) {
        bmap.value?.centerAndZoom(createBounds(window.BMapGL, props.bounds).getCenter(), bmap.value.getZoom())
      }
      bmap.value?.setDisplayOptions({
        poiText: false, // 隐藏poi标注
        poiIcon: false, // 隐藏poi图标
        building: false, // 隐藏楼块
      })
    }
  },
  { immediate: true },
)

onUnmounted(() => {
  bmap.value?.removeOverlay(groundOverlay.value)
})
</script>
